<template>
    <div class="page page-my-awards" :class="{'bg-red': !!myDetail}">
        <div v-if="myDetail" class="page__inner">
            <my-awards-notice />
            <div class="sect">
                <div class="mod my-awards-list">
                    <div class="mod__hd">
                        <h1 class="mod__h1 ta_center">初赛战绩</h1>
                    </div>
                    <div class="mod_bd">
                        <txt-wait-res v-if="isBefore(preRes)" :time="preRes" />
                        <div v-else class="mod__txt">
                            <div v-if="myPreAwards" class="mod_desc">
                                初赛排名<k-txt-rank :value="preRank" />，得分<span class="red">{{preScore}}</span>，<k-txt-advance :value="isAdvance" />，获得
                                </div>
                            <ul v-if="myPreAwards">
                                <li v-for="item in myPreAwards" :key="item.id">
                                    <img class="award-img" :src="item.img" :alt="item.name" />
                                </li>
                            </ul>
                            <div v-else class="txt-no-data">
                                <div class="ta_left">尊敬的用户,你好!<br>很遗憾你没有在规定的时间内参加完成至少<span class="red">1</span>个完整的擂台，所以没有成绩。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="isAdvance" class="sect">
                <div class="mod my-awards-list">
                    <div class="mod__hd">
                        <h1 class="mod__h1 ta_center">决赛战绩</h1>
                    </div>
                    <div class="mod_bd">
                        <txt-wait-res v-if="isBefore(finalRes)" :time="finalRes" />
                        <div v-else class="mod__txt">
                            <div v-if="myFinalAwards" class="mod_desc">决赛排名<k-txt-rank :value="finalRank" />，得分<span class="red">{{finalScore}}</span>分，获得</div>
                            <ul v-if="myFinalAwards">
                                <li v-for="item in myFinalAwards" :key="item.id">
                                    <img class="award-img" :src="item.img" :alt="item.name" />
                                </li>
                            </ul>
                            <div v-else class="txt-no-data">
                                <div class="ta_left">尊敬的用户,你好!<br>很遗憾你没有在规定的时间内完成决赛，所以没有决赛相应的奖项哦！</div>
                            </div>
                        </div>
                        <!-- <txt-no-data /> -->
                    </div>
                </div>
            </div>

        </div>
        <div v-else class="page__inner">
            <txt-no-data v-if="!isValidUser" message="您未登录，请先登录" />
            <txt-loading v-else />
        </div>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters
    } from 'vuex'
    import MyAwardsNotice from './awards/notice'

    export default {
        components: {
            [MyAwardsNotice.name] : MyAwardsNotice
        },
        computed: {
            ...mapState(['myDetail', 'myAddress', 'myAwards']),
            ...mapGetters(['myUid', 'realityCupId', 'isBefore', 'isAfter', 'preRes', 'finalRes', 'awardTime', 'addressEnd', 'myPreAwards',
                'myFinalAwards',
                'preRank', 'finalRank', 'preScore', 'finalScore', 'isAdvance', 'finishCupNum', 'isValidUser'
            ])
        },
        methods: {

        },
        async created() {

        }
    };

</script>
